import { Link } from "react-router-dom";
import { ArtworkCard } from "../ArtworkCard";

export const FeaturedArtSection = ({ featured }) => (
  <section data-testid="featured-art-section" className="px-6 md:px-12 lg:px-24 py-20">
    <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
      <div>
        <p className="label-eyebrow text-[#1E3A8A]">— Featured Art</p>
        <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight font-medium mt-2 text-[#111]">
          A curated selection
        </h2>
        <p className="text-[#555] mt-2 max-w-lg">
          Highlighted works from our network of African masters, updated weekly.
        </p>
      </div>
      <Link
        to="/gallery"
        className="label-eyebrow border border-[#1E3A8A] text-[#1E3A8A] hover:bg-[#1E3A8A] hover:text-white transition-colors px-5 py-3"
      >
        View all art →
      </Link>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
      {featured.slice(0, 4).map((art) => (
        <ArtworkCard key={art.id} artwork={art} aspect="square" />
      ))}
    </div>
  </section>
);
